import { createStore } from 'vuex';
const debug = process.env.NODE_ENV !== 'production';

// Modules
import areas from './modules/areas';
import autoTest from './modules/autoTest';
import brokerPortal from './modules/brokerPortal';
import carriers from './modules/carriers';
import editRequests from './modules/editRequests';
import identityAlerts from './modules/identityAlerts';
import savedSearches from './modules/savedSearches';
import laneSearches from './modules/laneSearches';
import loading from './modules/loading';
import PaymentMethods from './modules/paymentMethods';
import userInvitations from './modules/userInvitations';
import carrierInvitations from './modules/carrierInvitations';
import users from './modules/users';
import insights from './modules/Insights';
import subscriptions from './modules/subscriptions';
import contracts from './modules/contracts';
import vehicles from './modules/vehicles';
import fraudSearch from './modules/fraudSearch';
import companyChangeOrders from './modules/companyChangeOrders';
import reports from './modules/reports';
import rateConfirmations from './modules/rateConfirmations';
import watchdog from './modules/watchdog';
import directory from './modules/directory';
import loads from './modules/loads';
import alertsStore from './modules/alertsStore';
import notes from './modules/notes';
import teams from './modules/teams';
import loadboard from './modules/loadboard';
import identityVerification from './modules/IdentityVerification';
import activities from './modules/activities';
import mapbox from './modules/mapbox';

export default createStore({
  state: {},
  modules: {
    areas,
    autoTest,
    brokerPortal,
    carriers,
    editRequests,
    identityAlerts,
    laneSearches,
    loading,
    PaymentMethods,
    savedSearches,
    subscriptions,
    userInvitations,
    carrierInvitations,
    users,
    insights,
    contracts,
    vehicles,
    fraudSearch,
    companyChangeOrders,
    reports,
    rateConfirmations,
    watchdog,
    directory,
    loads,
    alertsStore,
    notes,
    teams,
    loadboard,
    identityVerification,
    activities,
    mapbox,
  },
  mutations: {},
  actions: {},
  strict: debug,
});
